/** Canonical QR & Links routes. Import these instead of string literals. */
export const LINKS_ROUTES = Object.freeze({
  LIST: '/links',
  FORMS: '/links/forms',
  FORM_NEW: '/links/forms/new',
  FORM_CONSENT: '/links/forms/consent',
  FORM_DETAIL: '/links/forms/:formId',
  FORM_EDIT: '/links/forms/:formId/edit',
  CAMPAIGNS: '/links/campaigns',
  CAMPAIGN_DETAIL: '/links/campaigns/:id',
  OVERVIEW: '/links/overview',
  // Last: React Router ranks the static siblings (forms, campaigns, overview)
  // above `:code` anyway (U09); routes.test.jsx pins it.
  DETAIL: '/links/:code',
});

/** Route table, wired in routes.jsx. Every tracker page is private. */
export const LINKS_ROUTE_CONFIG = Object.freeze(
  Object.values(LINKS_ROUTES).map((path) => Object.freeze({ path, isPrivate: true }))
);

/**
 * Link detail path. Codes are upper-cased client-side (U09).
 * @param {string} code
 * @returns {string}
 */
export function linkDetailPath(code) {
  return `/links/${encodeURIComponent(String(code || '').toUpperCase())}`;
}

/**
 * Campaign page path.
 * @param {string} id - Campaign UUID.
 * @returns {string}
 */
export function campaignPath(id) {
  return `/links/campaigns/${encodeURIComponent(String(id || ''))}`;
}

/**
 * Lead form page path (A3b).
 * @param {string} formId
 * @returns {string}
 */
export function formPath(formId) {
  return `/links/forms/${encodeURIComponent(String(formId || ''))}`;
}

/**
 * Form editor path (A3).
 * @param {string} formId
 * @returns {string}
 */
export function formEditPath(formId) {
  return `${formPath(formId)}/edit`;
}
